
const util = require('util');

const _ = require('lodash');

const bytes = require('bytes');

const vb = require('../definition');

const {
	unwrap,
} = require('../util');

vb.totalFileMaxSize = (maxSize, messageFormat = 'суммарный размер не более %s') => {
	return {
		validator: v => {
			const maxSizeValue = bytes.parse(unwrap(maxSize));
			const totalSize = _.sum(_.map(v, f => {
				const file = unwrap(f);
				const fileSize = file && file.Size();
				return fileSize || 0;
			}));
			return totalSize <= maxSizeValue;
		},
		message: () => {
			const maxSizeRepr = bytes(bytes.parse(unwrap(maxSize)));
			return util.format(messageFormat, maxSizeRepr);
		},
	};
};
